import { FileEndosoDto } from "../models/fileEndosoDto"
import { columns } from "../../../../dtos/columns";
import { Dialog, DialogContent, DialogTitle, Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import {Download} from '@mui/icons-material';

interface IProps {
    handleDownload: (e: FileEndosoDto) => void
}

export function useColumnsArchivos({handleDownload} : IProps){
    const COLUMNSARCHIVOS: columns<FileEndosoDto>[] = [
        {
            name: 'Nombre Archivo',
            selector: (row: FileEndosoDto) => row.fileName,
            sortable: true,
            sortField: 'fileName',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Acciones',
            selector: (row: FileEndosoDto) => row.fileName,
            cell: (row: FileEndosoDto) => (
                <MButton
                    variant="contained"
                    color='info'
                    style={{width: "160px", textAlign: "left"}}
                    startIcon={<Download/>}
                    onClick={() => handleDownload(row)}
                >
                    Descargar
                </MButton>  
            ),
            sortable: true,
            sortField: 'fileName',
            wrap: true,
            alling: 'left',
            export: true,
        }
    ]

    return {COLUMNSARCHIVOS}
}